import { render, staticRenderFns } from "./view-form.vue?vue&type=template&id=a2d68806&"
import script from "./view-form.vue?vue&type=script&lang=js&"
export * from "./view-form.vue?vue&type=script&lang=js&"
import style0 from "./view-form.vue?vue&type=style&index=0&id=a2d68806&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports